<template>
  <div class="success-page">
    <h3></h3>
    <div class="reg-meet">
      <div v-if="visitorObj.Activitys && visitorObj.Activitys.length > 0">
        <div
          class="meet-item"
          v-for="(item, index) in visitorObj.Activitys"
          :key="index"
        >
          <div class="meet-name-row">
            <span class="activity-name">{{ item.ActivitysName }}</span>
           
            <van-tag v-if="!item.CheckState&&item.ActivitysIsneedCheck==true" type="primary" color="#003df2" class="status-tag">待审核<span class="tag-en">Pending Review</span></van-tag>
            <van-tag
              v-if="item.CheckState === '已通过'"
              type="primary"
              color="#ff8080"
              >已通过</van-tag
            >
            <van-tag
              v-if="item.CheckState === '未通过'"
              type="primary"
              color="#ff8080"
              >未通过</van-tag
            >
          </div>
          <div class="ename-row"> <span class="activity-ename">{{ item.ActivitysEname }}</span></div>
          <div class="divider-line"></div>
          <div class="time-address-row">
            <div class="time-col">
              <span class="time-cn">{{ item.ActivityTime }}</span>
              <span class="time-en">{{ formatDateToEn(item.ActivityTime) }}</span>
            </div>
            <div class="address-col">
              <img :src="dwIcon" alt="" class="dw-icon"  v-if="item.ActivityAddress"/>
              <div class="address-text">
                <span v-for="(addr, idx) in (item.ActivityAddress || '').split('/')" :key="idx">{{ addr }}</span>
              </div>
            </div>
          </div>          
        </div>
      </div>
      <!-- 单参展报名 -->
      <div v-else>
        <div class="meet-item">
          <div>
            <span style="font-size: 18px">{{
              visitorObj.VisitorExtField1 === '观展' ? '参展报名' : '合作报名'
            }}</span>
          </div>
          <div>
            <span>{{ visitorObj.VisitorName }}</span>
            <span>{{ visitorObj.VisitorComName }}</span>
          </div>
          <div class="check-btn-wrap">
            <van-button
              type="primary"
              size="mini"
              style="margin-right: 2vw"
              @click="checkQrHandler"
              >查看入场码</van-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="opera-wrap">
      <div
        class="opera-item"
        v-for="(item, index) in operas"
        :key="index"
        @click="clickHandler(item.cn)"
      >
        {{ item.cn }}
        <span class="opera-en">{{ item.en }}</span>
      </div>
    </div>
  </div>
  <!-- 图片分享邀请 -->
  <div class="yh-mask" v-if="showImgYq" @click="closeMask">
    <img :src="yqImgUrl" alt="" class="yqImgUrl" v-if="yqImgUrl" />
    <div class="yh-img-con" ref="yqEle" v-else>
      <img :src="yqBg" alt="" @load="yqBgLoaded" />
      <div class="yq-con" ref="yqConRef">
        <div 
          v-for="(act, idx) in myactivity.split(',').filter(a => a.trim())" 
          :key="idx" 
          :style="{
            maxWidth: '65%', 
            background: 'rgba(255, 255, 255, 0.1)', 
            borderRadius: '4px', 
            marginBottom: '2px',
            padding: '2px 4px',
            lineHeight: '1.2',
            fontSize: activityFontSize + 'px'
          }"
        >
          <div>{{ act }}</div>
          <div class="activity-en">{{ myactivityEn.split(',')[idx] }}</div>
        </div>
        
      </div>
      <div
          style="
            position: absolute;
            bottom: 13.9%;
            right: 5.6%;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <div style="background: #fff; padding: 5px; display: inline-block;">
            <qrcode-vue :value="yhLink" :size="70"></qrcode-vue>
          </div>
          <p style="margin: 5px 0 0 0; font-size: 12px; color: white; text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);">报名二维码</p>
          <p style="margin: 5px 0 0 0; font-size: 12px; color: white; text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);">Registration QR Code</p>
        </div>
    </div>
    <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 12px; padding: 16px 0;background-color: #0028ed;">
      <img v-if="isWeX" src="@/assets/closemobie.png" class="close-btn-img" style="width: 180px; height: auto;" @click="closeMask" />
      <van-button v-if="!isWeX" type="primary" round @click="download" class="download-btn">下载分享<br /><span class="btn-en">Download</span></van-button>
      <img src="@/assets/sclose.png" class="close-btn-img" @click="closeMask" />
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import api from '@/api'
import { useStore } from 'vuex'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
import yqBg from '@/assets/yq.png'
import dwIcon from '@/assets/dwicon.png'
import QrcodeVue from 'qrcode.vue'
import html2canvas from 'html2canvas'
import { showLoadingToast, showToast, showFailToast } from 'vant'
const store = useStore()
const route = useRoute()
// const ExhCode = computed(() => store.state.ExhCode)
// const gconfig = computed(() => getConfigObj(store.state.gconfig))
const VisitorID = computed(() => store.state.VisitorID)
const isWeX = computed(() => store.state.isWeX)
const ExhCode = computed(() => {
  return store.state.ExhCode
})
const visitorObj = ref({})
const yhLink = ref(
  `https://reg.alljoy.com.cn/VisitroRegist/26cihc/#/login?ExhCode=2864a4033f26&invitesource=1&invitesourceID=${VisitorID.value}`
)
const myactivity = ref('')
const myactivityEn = ref('')
const yqConRef = ref(null)
const activityFontSize = ref(13)

// 自动计算字体大小
const calculateFontSize = () => {
  console.log('calculateFontSize called')
  nextTick(() => {
    console.log('yqConRef.value:', yqConRef.value)
    if (!yqConRef.value) {
      console.log('yqConRef not ready, skipping')
      return
    }
    
    const activities = myactivity.value.split(',').filter(a => a.trim())
    const activityCount = activities.length
    console.log('activityCount:', activityCount)
    
    // 更精细的字体大小调整策略
    // 根据活动数量和可能的文字长度动态调整
    if (activityCount === 0) {
      activityFontSize.value = 13
    } else if (activityCount === 1) {
      activityFontSize.value = 13
    } else if (activityCount === 2) {
      activityFontSize.value = 13
    } else if (activityCount === 3) {
      activityFontSize.value = 13
    } else if (activityCount === 4) {
      activityFontSize.value = 11
    } else if (activityCount === 5) {
      activityFontSize.value = 9
    } else if (activityCount === 6) {
      activityFontSize.value = 9
    } else if (activityCount === 7) {
      activityFontSize.value = 8
    } else {
      // 8个及以上，进一步缩小
      activityFontSize.value = Math.max(8, 14 - activityCount * 0.8)
    }
    console.log('activityFontSize', activityFontSize.value)
  })
}

// 监听 myactivity 变化，自动计算字体大小
watch(myactivity, () => {
  calculateFontSize()
})

const closeMask = () => {
  showImgYq.value = false
}
const regType = ref(route.query.regType) //从链接参数里获取
const getMsg = async () => {
  const res = await api.getVisitorApi({ VisitorID: VisitorID.value })
  const jmRes = JSON.parse(decryptionECB(res.data))
  visitorObj.value = jmRes
  console.log(visitorObj.value)
  console.log('regtype',regType.value)
   if (regType.value === 'st') {
      console.log('st', visitorObj.value.VisitorExtField1)
    if (visitorObj.value.VisitorExtField1.indexOf('参会') <0) {
      //跳转到合作页面
      router.push({ path: '/changeMeet' })
    }
  } else if (regType.value === 'hz') {
    if (visitorObj.value.VisitorExtField1.indexOf('合作') <0) {
      //跳转到合作页面
      router.push({ path: '/changeCo' })
    }
  } 
  if (visitorObj.value.Activitys) {
    // 循环activitys，将会议名称拼接到myactivitys
    console.log('visitorObj.value.Activitys', visitorObj.value.Activitys)
    visitorObj.value.Activitys.forEach((item) => {
      myactivity.value += item.ActivitysName + ','
      myactivityEn.value += (item.ActivitysEname || '') + ','
    })
        
    // 会议报名
    operas.value = [
      { cn: '回到首页', en: 'Back to Home' },
      { cn: '签到', en: 'Check-in' },
      { cn: '修改报名', en: 'Edit Registration' },
      { cn: '协助他人报名', en: 'Register on Behalf of Others' },
      { cn: '我要合作', en: 'Cooperation Opportunities ' },
      { cn: '大会日程', en: 'Conference Agenda' },      
      { cn: '往届回顾', en: 'Past Events' },
      { cn: '交通住宿', en: 'Travel & Accommodation' },
      { cn: '官网', en: 'Official Website' },
      { cn: '分享邀请', en: 'Share Invitation' },
      { cn: '图片直播', en: 'Photo Live' },
      { cn: '视频直播', en: 'Video Live' }
    ]
    sessionStorage.setItem(
      'activitys',
      JSON.stringify(visitorObj.value.Activitys)
    )
    
  }
  if (visitorObj.value.VisitorExtField1 === '参展报名') {
    // 参观报名
    operas.value = [
      { cn: '回到首页', en: 'Back to Home' },
      { cn: '签到', en: 'Check-in' },
      { cn: '修改报名', en: 'Edit Registration' },
      { cn: '协助他人报名', en: 'Register on Behalf of Others' },
      { cn: '我要合作', en: 'Cooperation Opportunities ' },
      { cn: '大会日程', en: 'Conference Agenda' },
      { cn: '往届回顾', en: 'Past Events' },
      { cn: '交通住宿', en: 'Travel & Accommodation' },
      { cn: '官网', en: 'Official Website' },
      { cn: '分享邀请', en: 'Share Invitation' },
      { cn: '图片直播', en: 'Photo Live' },
      { cn: '视频直播', en: 'Video Live' }
    ]
  } else if (visitorObj.value.VisitorExtField1 === '合作报名') {
    // 合作报名
    operas.value = [
      { cn: '回到首页', en: 'Back to Home' },
      { cn: '签到', en: 'Check-in' },
      { cn: '修改报名', en: 'Edit Registration' },
      { cn: '协助他人报名', en: 'Register on Behalf of Others' },
      { cn: '我要合作', en: 'Cooperation Opportunities ' },
      { cn: '大会日程', en: 'Conference Agenda' },
      { cn: '往届回顾', en: 'Past Events' },
      { cn: '交通住宿', en: 'Travel & Accommodation' },
      { cn: '官网', en: 'Official Website' },
      { cn: '分享邀请', en: 'Share Invitation' },
      { cn: '图片直播', en: 'Photo Live' },
      { cn: '视频直播', en: 'Video Live' }
    ]
  }
}
onMounted(() => {
  getMsg()
  if (isWeX.value) {
    wx.getWXSign()
  }
})

const router = useRouter()

const operas = ref([
  { cn: '回到首页', en: 'Back to Home' },
      { cn: '签到', en: 'Check-in' },
      { cn: '修改报名', en: 'Edit Registration' },
      { cn: '协助他人报名', en: 'Register on Behalf of Others' },
      { cn: '我要合作', en: 'Cooperation Opportunities ' },
      { cn: '大会日程', en: 'Conference Agenda' },
      { cn: '往届回顾', en: 'Past Events' },
      { cn: '交通住宿', en: 'Travel & Accommodation' },
      { cn: '官网', en: 'Official Website' },
      { cn: '分享邀请', en: 'Share Invitation' },
      { cn: '图片直播', en: 'Photo Live' },
      { cn: '视频直播', en: 'Video Live' }
])
const showComingSoon = () => {
  showToast({
    message: '敬请期待 Coming Soon \n 2026-03-25',
    position: 'middle',
    className: 'custom-toast'
  })
}
const sign = () => {
  api
    .CheckSign({
      visitorid: VisitorID.value,
      ExhCode: ExhCode.value
    })
    .then((res) => {
      if (res.code === 200) {
        showToast({
          message: '您已签到成功！',
          wordBreak: 'break-all',
          type: 'success'
        })
        checkQrHandler()
      }
    })
}
// 日期转换为英文格式
const formatDateToEn = (dateStr) => {
  if (!dateStr) return ''
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  
  // 匹配 "9月8日-11日" 或 "9月8日~11日" 格式
  const rangeMatch = dateStr.match(/(\d{1,2})月(\d{1,2})日[\-\~](\d{1,2})日/)
  if (rangeMatch) {
    const [, month, startDay, endDay] = rangeMatch
    return `${months[parseInt(month) - 1]} ${parseInt(startDay)}-${parseInt(endDay)}`
  }
  
  // 匹配 "3月25日" 格式（无年份）
  const mdMatch = dateStr.match(/^(\d{1,2})月(\d{1,2})日$/)
  if (mdMatch) {
    const [, month, day] = mdMatch
    return `${months[parseInt(month) - 1]} ${parseInt(day)}`
  }
  
  // 匹配 "5月" 格式（仅月份）
  const monthOnlyMatch = dateStr.match(/^(\d{1,2})月$/)
  if (monthOnlyMatch) {
    const [, month] = monthOnlyMatch
    return months[parseInt(month) - 1]
  }
  
  // 匹配中文日期格式，如 "2026年3月25日"
  const cnMatch = dateStr.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/)
  if (cnMatch) {
    const [, year, month, day] = cnMatch
    return `${months[parseInt(month) - 1]} ${parseInt(day)}, ${year}`
  }
  
  // 匹配 "2026-03-25" 格式
  const dashMatch = dateStr.match(/(\d{4})-(\d{1,2})-(\d{1,2})/)
  if (dashMatch) {
    const [, year, month, day] = dashMatch
    return `${months[parseInt(month) - 1]} ${parseInt(day)}, ${year}`
  }
  
  return dateStr
}
const clickHandler = (type) => {
  switch (type) {
    case '回到首页':
      router.push({ path: '/login', query: { ExhCode: ExhCode.value, openid: store.state.openid } })
      break
    case '修改报名':
      router.push({ path: '/changeMeet' })
      break
    case '大会日程':
       router.push({ path: '/schedule' })
       break
    case '协助他人报名':
      sessionStorage.setItem('invitesource', '1')
      router.push({ path: '/msg', query: { type: 'help' } })
      break
    case '我要合作':
      router.push({ path: '/changeCo' })
      break
    case '官网':
      window.location.href = 'https://www.cihcexpo.com/'
      break
    case '分享邀请':
      showImgYq.value = true
      // 等待 DOM 渲染后再计算字体大小
      nextTick(() => {
        setTimeout(() => {
          calculateFontSize()
        }, 100)
      })
      break
    case '签到':
      sign()
      break
    case '图片直播':
      showComingSoon()
      break
    case '视频直播':
      showComingSoon()
      break
    case '往届回顾':
      window.location.href = 'https://www.cihcexpo.com/introduction/review1.html'
      break
    case '交通住宿':
      router.push({ path: '/traffic' })
      break
  }
}

const checkQrHandler = () => {
  router.push({
    path: '/checkQr'
  })
}
const showImgYq = ref(false)
const yqEle = ref(null)
const yqImgUrl = ref('')
const createImg = () => {
  const element = yqEle.value // 获取需要生成图像的 DOM 元素
  html2canvas(element, {
    useCORS: true // 开启CORS支持
  }).then((canvas) => {
    yqImgUrl.value = canvas.toDataURL('image/png')
  })
}
const yqBgLoaded = () => {
  // 先计算字体大小，等待 DOM 更新后再生成图片
  calculateFontSize()
  nextTick(() => {
    setTimeout(() => {
      createImg()
    }, 200)
  })
}

const download = () => {
  var a = document.createElement('a') // 生成一个a元素
  var event = new MouseEvent('click') // 创建一个单击事件
  a.download = '图片邀请' // 设置图片名称
  a.href = yqImgUrl.value // 将生成的URL设置为a.href属性
  a.dispatchEvent(event)
}
</script>
<style lang="less">
.success-page {
  padding: 0 4vw 4vw;
  min-height: 100vh;
  background-image: url('~@/assets/success-bg.png');
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  h3 {
    text-align: left;
    padding-bottom: 3vw;
  }

  .reg-meet {
    .meet-item {
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      padding: 16px;
      border: 2px solid #8dc7ff;
      .meet-name-row {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        .activity-name {
          flex: 1;
          font-size: 18px;
          font-weight: 600;
          line-height: 1.5;
          word-break: break-word;
          text-align: left;
          color: #003df2;
        }
        .van-tag {
          flex-shrink: 0;
          white-space: nowrap;
          margin-top: 2px;
        }
        .status-tag {
          white-space: normal !important;
          text-align: center;
          line-height: 1.4;
          border-radius: 16px;
          padding: 2px 6px;
          display: inline-flex !important;
          flex-direction: column !important;
          align-items: center !important;
          .tag-en {
            font-size: 8px;
            display: block;
          }
        }
      }
      .ename-row {
        display: block !important;
        text-align: left !important;
        padding-top: 5px;
        .activity-ename {
           font-size: 14px;
          color: #333;
          text-align: left;
        }
      }
      .divider-line {
        height: 1px;
        background-color: #95d0fd;
        margin: 40px 0 10px 0;
      }
      .time-address-row {
        padding-top: 10px;
        color: #666;
        font-size: 13px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
      }
      .time-col {
        width: 35%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
        .time-cn {
          font-size: 17px;
          color: #016eff;
          font-weight: 600;
        }
        .time-en {
          font-size: 12px;
          color: #016eff;
        }
      }
      .address-col {
        width: 65%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        text-align: left;
        .dw-icon {
          width: 16px;
          height: 16px;
          margin-right: 6px;
          margin-top: 2px;
          flex-shrink: 0;
        }
        .address-text {
          display: flex;
          flex-direction: column;
          span {
            display: block;
          }
        }
      }
      .check-btn-wrap {
        display: flex;
        justify-content: flex-end;
        padding-top: 12px;
        border-top: 1px solid #f0f0f0;
        margin-top: 12px;
      }
    }
  }
  .opera-wrap {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 3vw; /* 增大间距 */
    .opera-item {
      color: #003df2;
      margin-bottom: 3vw; /* 增大底部间距 */
      width: calc(50% - 1.5vw); /* 调整宽度以适应新的间距 */
      border: 1px solid #003df2; /* 加粗边框 */
      padding: 4px 3px; /* 调整内边距 */
      text-align: center;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 12px; /* 增加圆角 */
      min-height: 60px; /* 增加最小高度 */
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 16px; /* 增加字体大小 */
      font-weight: 600; /* 增加字体粗细 */
      transition: all 0.3s ease; /* 添加过渡动画 */
      /* 添加悬停效果 */
      &:hover {
        background-color: #003df2;
        color: #fff;
        cursor: pointer;
        .opera-en {
          color: rgba(255, 255, 255, 0.8);
        }
      }
      &:active {
        background-color: #0028b8;
        color: #fff;
        .opera-en {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
    .opera-en {
      display: block;
      font-size: 12px;
      color: #003df2;
      font-weight: normal;
      margin-top: 4px;
    }
  }
}
.close-btn-img {
  width: auto;
  height: 57px;
  cursor: pointer;
}
.download-btn {
  background-color: #fff !important;
  color: #003df2 !important;
  border: 1px solid #003df2 !important;
  padding: 8px 20px;
  height: 52px;
  box-sizing: border-box;
  line-height: 1.3;
  margin-top: 12px;
  .btn-en {
    font-size: 10px;
  }
}
.yh-mask {
   position: fixed;
  top: 50%;
  left: 50%;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
  transform: translate(-50%, -50%);
  border: 2px solid #ccc; /* 添加外边框 */
  border-radius: 8px; /* 可选：添加圆角使边框更美观 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5); /* 可选：添加阴影增强视觉效果 */
  margin-bottom: 12px;
  .yh-img-con {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .yq-con {
      position: absolute;
      left: 50%;
      top: 110vw;
      margin-left: -50%;
      width: 100%;
      //height: 30vw;
      color:#fff;
      text-align: left;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      overflow: hidden;
      .activity-en {
       // font-size: 12px;
        font-weight: normal;
        opacity: 0.8;
      }
    }
  }
  .yqImgUrl {
    width: 100%;
  }
  .close-btn-wrap {
    text-align: center;
    padding: 12px 0;
  }
}
@media screen and (min-width: 768px) {
  .yh-mask {
    width: 500px;
  }
  .yh-mask .yh-img-con {
    width: 100%;
    margin: 0 auto;
  }
  .yh-mask .yh-img-con .yq-con {
    top: 63%;
    height: auto;
    max-height: 20%;
  }
  .yh-mask .yqImgUrl {
    width: 100%;
    display: block;
  }
}
</style>

<style lang="less">
/* Toast 全局样式（不能 scoped，因为 Toast 挂载在 body 上） */
.custom-toast {
  min-width: 200px;
  max-width: 80%;
  padding: 20px 24px;
  font-size: 16px;
}
</style>
